import { IKnmListByPlanBooleanSelectOption } from '../interfaces/IKnmListByPlanBooleanSelectOption';

export const knmListByPlanBooleanSelectOptions: IKnmListByPlanBooleanSelectOption[] = [
  {
    id: 0,
    label: 'Да',
    value: true,
  },
  {
    id: 1,
    label: 'Нет',
    value: false,
  },
];
